import api from './api';

export const savedViewService = {
  list: () => api.get('/saved-views'),
  create: (data) => api.post('/saved-views', data),
  update: (id, data) => api.put(`/saved-views/${id}`, data),
  delete: (id) => api.delete(`/saved-views/${id}`),
};
